var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 11.8333C0.666748 5.35733 6.87475 0.5 14.0001 0.5C21.1254 0.5 27.3334 5.35733 27.3334 11.8333C27.3334 18.3093 21.1254 23.1667 14.0001 23.1667C13.1294 23.1667 12.2774 23.096 11.4521 22.96C11.3281 23.0573 11.1147 23.2333 10.8521 23.4187C10.0934 23.9533 8.99875 24.5 7.33342 24.5C6.97979 24.5 6.64065 24.3595 6.39061 24.1095C6.14056 23.8594 6.00008 23.5203 6.00008 23.1667C6.00008 22.4333 6.19075 21.5213 5.87475 20.8253C2.76941 18.7973 0.666748 15.564 0.666748 11.8333Z",
    fill: "#869898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/Ic_Chat.6638a7b1b9961c57d04a63c2ff375d46.svg";
export { ForwardRef as ReactComponent };